import { useIntl } from 'react-intl'

import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { getChatTripPlannerNewChatPath } from 'tripPlanner/config'

interface Props {
  searchQuery?: string
}

function HotelSearchTripPlannerBanner({ searchQuery }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'PVW1UinD3sEdbEg6vIBh',
    defaultMessage: 'Keep exploring with AI Trip Planner',
  })
  const description = intl.formatMessage({
    id: 's3MHzyeZWAHS-p8SxRBI',
    defaultMessage: 'Tell us more about what you’re looking for and discover personalised offers that better match your needs.',
  })
  const tryTripPlannerLabel = intl.formatMessage({
    id: 'DhIVDezTjq_7AwjZ55h6',
    defaultMessage: 'Try Trip Planner',
  })
  const tripPlannerHref = getChatTripPlannerNewChatPath(searchQuery)

  return (
    <MessageBanner
      data-testid="hotel-search-trip-planner-banner"
      kind="informational"
      heading={heading}
      primaryActionButtonProps={{
        children: tryTripPlannerLabel,
        to: tripPlannerHref,
        target: '_blank',
        size: 'medium',
        shape: 'round',
      }}
    >
      {description}
    </MessageBanner>
  )
}

export default HotelSearchTripPlannerBanner
